import { render, staticRenderFns } from "./SwiperMultiRowSlides.vue?vue&type=template&id=ceb01334&scoped=true&"
import script from "./SwiperMultiRowSlides.vue?vue&type=script&lang=js&"
export * from "./SwiperMultiRowSlides.vue?vue&type=script&lang=js&"
import style0 from "./SwiperMultiRowSlides.vue?vue&type=style&index=0&id=ceb01334&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceb01334",
  null
  
)

export default component.exports